<div class="upload_Video_Section" style="width: 100% ; margin: 0 auto;">
  <div *ngIf="isUploading" class="loading-container">
    <div class="spinner-box">
      <div class="circle-border"></div>
    </div>
    <div class="progress-text">Uploading... {{progress.percentage}}%</div>
  </div>

  <div class="d-flex gap-12" *ngIf='videolink && !isUploading' style=" width: 100%;  margin: 0 auto;">
    <div class="VideoDisplayCard">
      <div class="affichage">
        <div *ngIf='videolink' class="videoLinkDisplay">
          <video width="100%" height="100%" [autoplay]="false" controls>
            <source [src]="videolink" type="video/mp4">
          </video>
        </div>
        <div *ngIf='image'>
          <video width="100%" height="100%" [autoplay]="false" controls>
            <source [src]="videolink" type="video/mp4">
          </video>
        </div>
      </div>
      <div *ngIf='!videolink' [ngClass]=" videolink || image ? 'image1n': 'image1'">

        <div class="change text-center">
          <button type="button" md-button (click)="videoFileInput.click()"><img
              src="../../../assets/images/upload.svg" /></button>
          <input hidden type="file" #videoFileInput (change)="selectFile($event)" accept='.mp4,.ogg' />
          <button class="btn-successs" [disabled]="selectedVideo">Upload your video here</button>
        </div>
      </div>
    </div>
    <div class="uploadCard">
      <div class="change" *ngIf='videolink'>
        <button type="button" md-button (click)="videoFileInput.click()"><img
            src="../../../assets/images/upload.svg" /></button>
        <div> <input hidden type="file" #videoFileInput (change)="selectFile($event)" accept='.mp4,.ogg' /> </div>
        <div>
          <button class="btn-change" [disabled]="selectedVideo">Change your video</button>
          <span class="separator-text"
            style="text-align: center; color: #5e5e5e!important; font-size: 10px; display: block;">Or</span>
          <button style="font-size: 11px; color: #5e5e5eb5;" class="btn-url" (click)="URLVideoInput()">Change video
            from URL</button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf='!videolink && !isUploading' [ngClass]=" videolink || image ? 'affichage1n': 'affichage1'" class="padd0">
    <div class="blocimage">
      <div class="affichage">
        <div [ngClass]=" videolink || image ? 'image1n': 'image1'">
          <div class="img1 text-center" (click)="videoFileInput.click()">
            <button type="button" md-button><img src="../../../assets/images/upload.svg" /></button>
            <input hidden type="file" #videoFileInput (change)="selectFile($event)" accept='.mp4,.ogg' />
          </div>
          <div class="d-flex flex-column align-items-center">
            <button class="btn-change" (click)="videoFileInput.click()" [disabled]="selectedVideo">Click to upload your
              video</button>
            <span class="separator-text">Or</span>
            <button class="btn-url" (click)="URLVideoInput()">Add video from URL</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>